module.exports = __webpack_public_path__ + "img/Suola_Deambulante_DX.b323bfdd.png";